<div
  role="status"
  class="w-full h-full items-center justify-center"
  *ngIf="isLoadingTimeline"
>
  <svg
    aria-hidden="true"
    class="w-10 h-10 2xl:w-12 2xl:h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#141F58] items-center justify-center mx-auto"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
</div>

<div *ngIf="!timelineEvolution.length && !isLoadingTimeline" class="flex items-center justify-center w-full">
  <span class="text-[0.85em] 2xl:text-[0.95em] xl:text-[1.2em] 3xl:text-[1.3em] 4xl:text-[1.4em] text-gray-500">Non ci sono dati da mostrare.</span>
</div>

<div class="flex flex-col h-full gap-3 2xl:gap-6 justify-center pt-0 xl:pt-8 2xl:pt-10">
  <!-- FORECAST -->
  <div 
    *ngIf="hasForecastData"
    class="flex items-center justify-center w-full">
    <ol
      *ngIf="!isLoadingTimeline"
      class="flex flex-row items-center justify-between w-full h-full overflow-x-auto scrollbar2"
    >
      <li
        *ngFor="let pointInTime of timelineEvolution"
        class="relative mb-5 2xl:mb-6 sm:mb-0 min-w-[92px] 2xl:min-w-[104px] w-full h-full flex-1"
      >
        <div class="flex items-center">
          <div
            class="z-1 flex items-center justify-center w-5 h-5 2xl:w-6 2xl:h-6 bg-[] rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 2xl:w-5 2xl:h-5"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M8.5 9L11.5 12L8.5 15"
                  stroke="#cfcfcf"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M12.5 9L15.5 12L12.5 15"
                  stroke="#cfcfcf"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                  stroke="#cfcfcf"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
              </g>
            </svg>
          </div>
          <div
            class="w-full h-[1.5px] 2xl:h-[2px] bg-[#00CEBC] dark:bg-gray-700"
          ></div>
        </div>
        <div class="mt-2.3 relative z-1 2xl:mt-3 sm:pe-8">
          <time
            class="block mb-1.5 2xl:mb-2 text-[0.65rem] 2xl:text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
            >{{ pointInTime.datePoint.split("-").reverse().join("-") }}</time
          >
          
          <div class="max-h-10 2xl:max-h-20 mb-2 2xl:mb-0 overflow-y-auto scrollbarForRegions">
            <p
              *ngFor="let region of pointInTime.forecast"
              class="text-base text-[0.58rem] 2xl:text-[0.8rem] text-gray-500 dark:text-gray-400"
            >
              {{
                region === "Prov. Aut. di Trento"
                  ? "PA Trento"
                  : region === "Prov. Aut. di Bolzano"
                  ? "PA Bolzano"
                  : region === "Friuli Venezia Giulia"
                  ? "Friuli VG"
                  : region === "Emilia-Romagna" && timelineEvolution.length > 7
                  ? "Emilia R."
                  : region ==="Valle D'Aosta" && timelineEvolution.length > 7
                  ? "V. d'Aosta"
                  : region
              }}
            </p>
          </div>
        </div>
      </li>
    </ol>
  </div>

  <!-- ACTUAL -->
  <div 
    *ngIf="hasActualData"
    class="flex items-center justify-center w-full">
    <ol
      *ngIf="!isLoadingTimeline"
      class="flex flex-row items-center justify-between w-full h-full overflow-x-auto scrollbar2"
    >
      <li
        *ngFor="let pointInTime of timelineEvolution"
        class="relative mb-5 2xl:mb-6 sm:mb-0 min-w-[92px] 2xl:min-w-[104px] w-full h-full flex-1"
      >
        <div class="flex items-center">
          <div
            class="z-1 flex items-center justify-center w-5 h-5 2xl:w-6 2xl:h-6 bg-[] rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 2xl:w-5 2xl:h-5"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M8.5 9L11.5 12L8.5 15"
                  stroke="#cfcfcf"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M12.5 9L15.5 12L12.5 15"
                  stroke="#cfcfcf"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                  stroke="#cfcfcf"
                  stroke-width="1.5"
                  stroke-linecap="round"
                ></path>
              </g>
            </svg>
          </div>
          <div
            class="w-full h-[1.5px] 2xl:h-[2px] bg-[#141E58]"
          ></div>
        </div>
        <div class="mt-2.3 relative z-1 2xl:mt-3 sm:pe-8">
          <time
            class="block mb-1.5 2xl:mb-2 text-[0.65rem] 2xl:text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
            >{{ pointInTime.datePoint.split("-").reverse().join("-") }}</time
          >
          
          <div class="max-h-10 2xl:max-h-20 mb-2 2xl:mb-0 overflow-y-auto scrollbarForRegions">
            <p
              *ngFor="let region of pointInTime.actual"
              class="text-base text-[0.58rem] 2xl:text-[0.8rem] text-gray-500 dark:text-gray-400"
            >
              {{
                region === "Prov. Aut. di Trento"
                  ? "P.A. Trento"
                  : region === "Prov. Aut. di Bolzano"
                  ? "P.A. Bolzano"
                  : region === "Friuli Venezia Giulia"
                  ? "Friuli VG"
                  : region === "Emilia-Romagna" && timelineEvolution.length > 7
                  ? "Emilia R."
                  : region
              }}
            </p>
          </div>
        </div>
      </li>
    </ol>
  </div>
</div>